import { ConfiguredPrograms } from '@/components/ConfiguredPrograms';
import { MemberBenefits } from '@/components/MemberBenefits';
import { Spinner } from '@/components/Spinner';

import { ExistingConfirmStep } from './components/ExistingConfirmStep';
import { FormStep } from './components/FormStep';
import { PhoneStep } from './components/PhoneStep';
import {
  UnregisteredCustomerProvider,
  useUnregisteredCustomerContext,
} from './context/UnregisteredCustomerContext';
import { E_RegistrationStep } from './enums';

function UnregisteredCustomerContent() {
  const { step, loading, loyaltyPrograms } = useUnregisteredCustomerContext();

  if (loading) {
    return (
      <div className='flex h-full items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  return (
    <div className='space-y-6'>
      {loyaltyPrograms && <ConfiguredPrograms loyaltyPrograms={loyaltyPrograms} />}

      <MemberBenefits />

      {step === E_RegistrationStep.PHONE && <PhoneStep />}
      {step === E_RegistrationStep.EXISTING_CONFIRM && <ExistingConfirmStep />}
      {step === E_RegistrationStep.FORM && <FormStep />}
    </div>
  );
}

export function UnregisteredCustomer() {
  return (
    <UnregisteredCustomerProvider>
      <UnregisteredCustomerContent />
    </UnregisteredCustomerProvider>
  );
}
